// extracted by mini-css-extract-plugin
export var parcelRow = "_rc-0";